import request from "@/utils/request";
import qs from "qs";
/**
 * 查询资讯列表
 * @param params
 * @returns {*}
 */
export function getNewsList(params) {
  return request({
    url: "/busininfo/getList",
    method: "get",
    params
  });
}

/**
 * 查询资讯详情
 * @param params
 * @returns {*}
 */
export function getNewDetail(params) {
  return request({
    url: "/busininfo/getDetail",
    method: "get",
    params
  });
}

/**
 * 新增-编辑资讯
 * @param params
 * @returns {*}
 */
export function editNews(params) {
  return request.post("/busininfo/edit", qs.stringify(params));
}

/**
 * 修改资讯状态
 * @param params
 * @returns {*}
 */
export function updateNewsStatus(params) {
  return request.post("/busininfo/updateStatus", qs.stringify(params));
}
/**
 * 查询资讯作者列表
 * @param params
 * @returns {*}
 */
export function getAuthorList(params) {
  return request({
    url: "/busininfo/getAuthorList",
    method: "get",
    params
  });
}
